document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    const editorId = 'zwssgr_email_editor';
    const selector = document.querySelector('.zwssgr-template-selector');

    // Check if selector exists and initialize if available
    if (selector) {
        initZWSSGREditor();
    }

    function initZWSSGREditor() {
        // Set default template selection
        const defaultTemplate = 'template1';
        selector.value = defaultTemplate;

        // Initialize TinyMCE editor with default template content
        fetchTemplate(defaultTemplate)
            .then(function (content) {
                updateEditorContent(content);
            })
            .catch(function (error) {
                console.error('Error loading default template:', error);
            });

        // Set up event listeners
        selector.addEventListener('change', handleTemplateChange);
        setupEditorObserver();
    }

    function setupEditorObserver() {
        // Check if editor is already loaded
        if (tinymce.get(editorId)) {
            return;
        }

        const editorContainer = document.getElementById(editorId + '_ifr');
        if (!editorContainer) return;

        const observer = new MutationObserver(function (mutations) {
            if (tinymce.get(editorId)) {
                observer.disconnect();
            }
        });

        observer.observe(editorContainer.parentElement, {
            childList: true,
            subtree: true
        });
    }

    function handleTemplateChange(event) {
        const template = event.target.value;

        if (template === 'custom') {
            clearEditorContent(); // Clear the editor if "Custom" is selected
        } else {
            fetchTemplate(template)
                .then(function (content) {
                    updateEditorContent(content);
                })
                .catch(function (error) {
                    console.error('Error loading template:', error);
                });
        }
    }

    function fetchTemplate(template) {
        return new Promise(function (resolve, reject) {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', zwssgrAdminConfig.ajaxurl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

            xhr.onload = function () {
                if (xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText);
                        if (response.success) {
                            resolve(response.data.content);
                        } else {
                            reject(response.data);
                        }
                    } catch (e) {
                        reject('Invalid JSON response');
                    }
                } else {
                    reject('Request failed with status ' + xhr.status);
                }
            };

            xhr.onerror = function () {
                reject('Request failed');
            };

            const data = new URLSearchParams();
            data.append('action', zwssgrAdminConfig.action);
            data.append('nonce', zwssgrAdminConfig.nonce);
            data.append('template', template);

            xhr.send(data);
        });
    }

    function updateEditorContent(content) {
        const editor = tinymce.get(editorId);
        const textarea = document.getElementById(editorId);

        if (editor) {
            editor.setContent(content);
        }

        if (textarea) {
            textarea.value = content;
        }
    }

    function clearEditorContent() {
        const editor = tinymce.get(editorId);
        const textarea = document.getElementById(editorId);

        if (editor) {
            editor.setContent(''); // Clear TinyMCE content
        }

        if (textarea) {
            textarea.value = ''; // Clear the textarea content
        }
    }
});
